import { Component, AfterViewInit, inject } from '@angular/core';
import { AuthService } from '../../../authentication/auth.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { PageFooterComponent } from '../page-footer/page-footer.component';

@Component({
  selector: 'app-verification-email-sent-page',
  templateUrl: './verification-email-sent-page.component.html',
  styleUrls: ['./verification-email-sent-page.component.scss'],
  imports: [PageFooterComponent],
  standalone: true,
})
export class VerificationEmailSentPageComponent implements AfterViewInit {
  private auth = inject(AuthService);
  showSuccessMessage = false;

  private loadingService = inject(LoadingService);

  ngAfterViewInit(): void {
    this.loadingService.hide();
  }

  sendVerificationEmailAgain(): void {
    this.auth.sendVerificationEmailAgain(this.showSuccessMessage);
  }
}
